import { type RouteRecordRaw, createRouter, createWebHashHistory, createWebHistory } from 'vue-router';

// One route per product, each a separate lazy chunk. A prospect signing up for ZynoDisplay must not
// download Talk's hardware catalog, and `bundle-isolation.spec.ts` derives its chunk roots from the
// dynamic imports below — so adding a product here automatically puts it under the same isolation
// and dependency rules without touching the test.
//
// Paths carry no `/signup` prefix: this app is its own deployment (dist-signup) served at the root of
// the signup origin, so the wizard for Talk is `/talk`, not `/signup/talk`.
const routes: RouteRecordRaw[] = [
    { path: '/talk', component: () => import('./products/talk/signup-talk.vue') }

    // Coming: /suite (module + seat selection) and /display (device count, no hardware).
];

// Dev and the e2e preview build serve every app from one root, where this entry keeps its in-project
// path (…/embedded/signup/index.html) and a real route path can't be resolved — so route by hash
// there. Its own deployment serves the entry as `/`, where the paths above are the URLs themselves.
// Keyed off where the document actually came from rather than `import.meta.env.DEV`, because the e2e
// build is a production build served from the entry path.
const servedFromEntryPath = window.location.pathname.includes('/embedded/signup/');

const router = createRouter({
    history: servedFromEntryPath ? createWebHashHistory() : createWebHistory(),
    routes
});

export default router;
